import ComicCard from '@/components/feature/ComicCard';
import { featuredComics } from '@/mocks/comics';
import { Link } from 'react-router-dom';

export default function FeaturedGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-light text-foreground-900 mb-3">
            热门推荐
          </h2>
          <p className="text-sm text-foreground-500">
            精选最受欢迎的韩国漫画，每日更新不间断
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {featuredComics.map((comic, index) => (
            <ComicCard
              key={comic.id}
              {...comic}
              isFirst={index === 0}
            />
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/category/fantasy"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap group"
          >
            查看全部热门漫画
            <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}